<template>
  <div class="card">
    <div class="card-header d-flex justify-content-between align-items-center flex-wrap">
      <h4 class="mb-0">{{ $t("fournisseur.title") }}</h4>
      <a-button
        v-show="activeTab === 'suppliers'"
        type="primary"
        icon="plus"
        class="action-button"
        @click="onAddSupplier"
      >
        {{ $t("action.ajouter") }}
      </a-button>
    </div>
    <div class="card-body pt-2">
      <a-tabs :active-key="activeTab" class="fournisseurs-hub-tabs" @change="onTabChange">
        <a-tab-pane key="suppliers" :tab="$t('menu.fournisseurs')">
          <supplier-tab ref="supplierTab" />
        </a-tab-pane>
        <a-tab-pane key="invoices" :tab="$t('menu.factures')">
          <invoices-tab />
        </a-tab-pane>
        <a-tab-pane key="amortization" :tab="$t('decaissement.amortizationTab')">
          <amortization-tab />
        </a-tab-pane>
      </a-tabs>
    </div>
  </div>
</template>

<script>
import SupplierTab from "./SupplierTab.vue";
import InvoicesTab from "./InvoicesTab.vue";
import AmortizationTab from "./AmortizationTab.vue";

export default {
  name: "SupplierListPage",
  components: { SupplierTab, InvoicesTab, AmortizationTab },
  data() {
    return {
      activeTab: "suppliers",
    };
  },
  watch: {
    "$route.query.tab": {
      immediate: true,
      handler(tab) {
        if (tab === "invoices") this.activeTab = "invoices";
        else if (tab === "amortization") this.activeTab = "amortization";
        else this.activeTab = "suppliers";
      },
    },
  },
  methods: {
    onTabChange(key) {
      this.activeTab = key;
      const q = { ...this.$route.query };
      if (key === "invoices") q.tab = "invoices";
      else if (key === "amortization") q.tab = "amortization";
      else delete q.tab;
      this.$router.replace({ path: this.$route.path, query: q }).catch(() => {});
    },
    onAddSupplier() {
      const ref = this.$refs.supplierTab;
      if (ref && typeof ref.openModal === "function") {
        ref.openModal(null);
      }
    },
  },
};
</script>

<style scoped>
.fournisseurs-hub-tabs >>> .ant-tabs-bar {
  margin-bottom: 0;
}
</style>

<style>
@import "~@/views/compV3/common.css";
</style>
